import { render } from "./competition-filter.vue?vue&type=template&id=4782f30d&scoped=true"
import script from "./competition-filter.vue?vue&type=script&lang=js"
export * from "./competition-filter.vue?vue&type=script&lang=js"

import "./competition-filter.vue?vue&type=style&index=0&id=4782f30d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4782f30d"]])

export default __exports__